import {ADD_ALERT, REMOVE_ALERT} from 'constants/ActionTypes';

export function addAlert(text, type = null, timeout = null) {
  const payload = {text, type, timeout};
  return {type: ADD_ALERT, payload };
}

export function removeAlert(payload) {
  return {type: REMOVE_ALERT, payload}
}



// WEBPACK FOOTER //
// ./actions/Alerts.js